import React from 'react';
import { object } from 'prop-types';
import './RightContent.scss';

RightContent.propTypes = {
  children: object
};

function RightContent({ children }) {
  return <div className="dashboard-card__header-right-content">{children}</div>;
}

export default RightContent;
